export default __webpack_public_path__ + "static/tailored-posters-572a05d791320717dac7578f8a01f997.png";